import { LunchConfiguration, Module } from '@awo-care/shared-core';

/**
 * Lenient-Regel: Alt-Dokumente ohne isActive-Feld gelten als aktiv.
 * Immer diesen Helper nutzen, nie `if (module.isActive)` (filtert Alt-Module
 * fälschlich aus).
 */
export function isModuleActive(module: Module): boolean {
  return module.isActive !== false;
}

/** Aktive Module zuerst (nach Index), danach inaktive (nach Index). */
export function sortModulesActiveFirst(modules: Module[]): Module[] {
  return [...modules].sort((a, b) => {
    const rankA = isModuleActive(a) ? 0 : 1;
    const rankB = isModuleActive(b) ? 0 : 1;
    return rankA - rankB || a.index - b.index;
  });
}

/**
 * Liefert das aktive Modul, das die Modulnummer belegt (Eindeutigkeit gilt
 * nur unter aktiven Modulen; `excludeId` nimmt das eigene Modul aus).
 */
export function findModuleNumberConflict(
  index: number,
  modules: Module[],
  excludeId?: string
): Module | undefined {
  return modules.find(
    (m) => m.id !== excludeId && isModuleActive(m) && m.index === index
  );
}

/**
 * Liefert das aktive Modul, das die Modulnummer des zu reaktivierenden
 * Moduls belegt.
 */
export function findReactivationConflict(
  module: Module,
  allModules: Module[]
): Module | undefined {
  return findModuleNumberConflict(module.index, allModules, module.id);
}

/**
 * Bereinigt beim Reaktivieren Lunch-Referenzen auf inzwischen gelöschte
 * Konfigurationen (Löschen wird bei inaktiven Modulen nicht geblockt).
 * Liefert nur die zu ändernden Felder; `null` löscht das Feld.
 */
export function getStaleLunchReferenceUpdates(
  module: Module,
  lunchConfigurations: LunchConfiguration[]
): { mandatoryLunchId?: null; availableLunchIds?: string[] } {
  const validIds = new Set(lunchConfigurations.map((c) => c.id));
  const updates: { mandatoryLunchId?: null; availableLunchIds?: string[] } = {};

  if (module.mandatoryLunchId && !validIds.has(module.mandatoryLunchId)) {
    updates.mandatoryLunchId = null;
  }

  const available = module.availableLunchIds ?? [];
  const filtered = available.filter((id) => validIds.has(id));
  if (filtered.length !== available.length) {
    updates.availableLunchIds = filtered;
  }

  return updates;
}
